module.exports = __webpack_public_path__ + "07_bob_yellow.edf5bf49.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/07_bob_yellow.png
// module id = AG0V
// module chunks = 0